/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { RouteComponentProps, withRouter, NavLink } from 'react-router-dom';
import Cell from '../prepRoom/Cell';
import { useSelector, RootStateOrAny } from 'react-redux';
import KilledItem from './KilledItem';

// import { useEffect } from 'react';
// import { useDispatch } from 'react-redux';
// import { addToBoard, setPlayer } from '../../actions';
// import { toastr } from 'react-redux-toastr';

//  teszteleshez ezt a 4 sort kikommentelni, illetve a 18-tol 74-ig
//  igy automatikusan feltolti a tablat, ha a http://localhost:3000/game -re navigalunk 

function InGame(props: InGameProps) {
    // const dispatch = useDispatch();

    //testing only
    /*
    useEffect(() => {
        dispatch(setPlayer(2));
        dispatch(
            addToBoard([
                [
                    { char: 'F', player: 1 },
                    { char: 'B', player: 1 },
                    { char: '1', player: 1 },
                    { char: '2', player: 1 },
                    { char: '3', player: 1 },
                    { char: '2', player: 1 },
                ],
                [
                    { char: '10', player: 1 },
                    { char: '8', player: 1 },
                    { char: '6', player: 1 },
                    { char: '3', player: 1 },
                    { char: '4', player: 1 },
                    { char: '2', player: 1 },
                ],
                [
                    { char: '0', player: 0 },
                    { char: '0', player: 0 },
                    { char: '0', player: 0 },
                    { char: '0', player: 0 },
                    { char: '0', player: 0 },
                    { char: '0', player: 0 },
                ],
                [
                    { char: '0', player: 0 },
                    { char: '0', player: 0 },
                    { char: '0', player: 0 },
                    { char: '0', player: 0 },
                    { char: '0', player: 0 },
                    { char: '0', player: 0 },
                ],
                [
                    { char: '2', player: 2 },
                    { char: '2', player: 2 },
                    { char: 'B', player: 2 },
                    { char: 'B', player: 2 },
                    { char: '8', player: 2 },
                    { char: '6', player: 2 },
                ],
                [
                    { char: 'F', player: 2 },
                    { char: '1', player: 2 },
                    { char: '3', player: 2 },
                    { char: '4', player: 2 },
                    { char: '3', player: 2 },
                    { char: '10', player: 2 },
                ],
            ])
        );
        toastr.success('Sikeresen csatlakozva', 'Jó játékot!');
    }, []);
    */

    const { board, room, kills, player, winner } = useSelector(
        (state: RootStateOrAny) => state
    );

    const playerKills = kills[player - 1] || [];
    return (
        <div className='ui center aligned container'>
            <div
                className={`ui center aligned secondary inverted ${
                    winner > 0 ? 'green' : 'brown'
                } raised big segment`}
            >
                <h2>{room}. szoba</h2>
                {!winner ? (
                    <p>{player}. játékos köre</p>
                ) : (
                    <p>{winner} játékos nyert!!!</p>
                )}
                <table>
                    <tbody>
                        <tr>
                            {board[0].map((item: string, key: number) => {
                                return (
                                    <Cell
                                        name={item}
                                        prep={false}
                                        index={[0, key]}
                                    />
                                );
                            })}
                        </tr>
                        <tr>
                            {board[1].map((item: string, key: number) => {
                                return (
                                    <Cell
                                        name={item}
                                        prep={false}
                                        index={[1, key]}
                                    />
                                );
                            })}
                        </tr>
                        <tr>
                            {board[2].map((item: string, key: number) => {
                                return (
                                    <Cell
                                        name={item}
                                        prep={false}
                                        index={[2, key]}
                                    />
                                );
                            })}
                        </tr>
                        <tr>
                            {board[3].map((item: string, key: number) => {
                                return (
                                    <Cell
                                        name={item}
                                        prep={false}
                                        index={[3, key]}
                                    />
                                );
                            })}
                        </tr>
                        <tr>
                            {board[4].map((item: string, key: number) => {
                                return (
                                    <Cell
                                        name={item}
                                        prep={false}
                                        index={[4, key]}
                                    />
                                );
                            })}
                        </tr>
                        <tr>
                            {board[5].map((item: string, key: number) => {
                                return (
                                    <Cell
                                        name={item}
                                        prep={false}
                                        index={[5, key]}
                                    />
                                );
                            })}
                        </tr>
                    </tbody>
                </table>
                <br />
                {playerKills.length > 0 ? (
                    <>
                        <p>Leszedett bábuk:</p>
                        <table>
                            {playerKills.map((item: string, key: number) => {
                                return <KilledItem name={item} index={key} />;
                            })}
                        </table>
                    </>
                ) : (
                    ''
                )}
                {winner > 0 ? (
                    <NavLink exact to='/' className='positive ui button'>
                        <i className='home icon'></i>FŐOLDAL
                    </NavLink>
                ) : (
                    ''
                )}
            </div>
        </div>
    );
}

interface InGameProps extends RouteComponentProps {}
export default withRouter(InGame);
